module.exports = __webpack_public_path__ + "img/section5_img2_2.7bd76a38.svg";